import Devextreme from "@sonphat/devextreme";
export default function Helper({ $Core, emitter, $store }) {
    Devextreme.$Core = $Core;
    this.isKhoaLuong = {};

    this.ThongBaoToast = (type, msg) => {
        let ParamsError = {
            isVisible: true,
            message: msg,
            type: type,
        };
        emitter.emit("onToast", ParamsError);
    };

    this.RequestPost = async ({
        keyRequest = "api",
        ServicesBE = "Make",
        url = "",
        dataPost = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
        typeNotificationSuccess = "Toast",
        typeNotificationError = "Popup",
    }) => {
        // Bắt buộc truyền thông báo
        if (!msgCatch || !msgError) {
            $Helper.ThongBaoToast(
                "error",
                "Chưa thể gửi request! Vui lòng kiểm tra lại!"
            );
        }
        if (this.isKhoaLuong[keyRequest]) return;
        $store.startLoading();
        this.isKhoaLuong[keyRequest] = "pending...";
        try {
            let rs = await $Core.Requests.Post({
                ServicesBE,
                url,
                dataPost,
            });

            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                if (msgSuccess) {
                    if (typeNotificationSuccess == "Toast") {
                        $Helper.ThongBaoToast("success", msgSuccess);
                    } else if (typeNotificationSuccess == "Popup") {
                        $Helper.ThongBaoPopup({
                            type: "Success",
                            message_title: msgSuccess,
                        });
                    }
                }
            } else {
                if (typeNotificationError == "Popup") {
                    $Helper.ThongBaoPopup({
                        type: "Error",
                        message_title: msgError,
                        message: rs.message || rs.Message || "",
                    });
                } else if (typeNotificationError == "Toast") {
                    $Helper.ThongBaoToast(
                        "error",
                        msgError + " " + (rs.message || rs.Message || "")
                    );
                }
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            this.CatchRequest(error);
            // if (typeNotificationError == "Popup") {
            //     $Helper.ThongBaoPopup({
            //         type: "Error",
            //         message_title: msgCatch,
            //     });
            // } else if (typeNotificationError == "Toast") {
            //     $Helper.ThongBaoToast("error", msgCatch);
            // }
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: "Catch!",
            };
        } finally {
            this.isKhoaLuong[keyRequest] = undefined;
            $store.stopLoading();
        }
    };
    this.RequestGet = async ({
        ServicesBE = "Make",
        url = "",
        dataGet = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
    }) => {
        $store.startLoading();
        try {
            let rs = await $Core.Requests.Get({
                ServicesBE,
                url,
                dataGet,
            });
            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                if (msgSuccess) {
                    $Helper.ThongBaoToast("success", msgSuccess);
                }
            } else {
                if (msgError) {
                    $Helper.ThongBaoToast(
                        "error",
                        msgError + " " + (rs.message || rs.Message || "")
                    );
                }
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            this.CatchRequest(error);
            // if (msgCatch) {
            //     $Helper.ThongBaoToast("error", msgCatch);
            // }
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: msgCatch || "Catch!",
            };
        } finally {
            $store.stopLoading();
        }
    };

    this.StoreRequestPost = async ({
        keyRequest = "api",
        dispatch = "Common/RequestPost",
        ServicesBE = "Make",
        url = "",
        dataPost = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
    }) => {
        // Bắt buộc truyền thông báo
        if (!msgCatch || !msgError) {
            $Helper.ThongBaoToast(
                "error",
                "Chưa thể gửi request! Vui lòng kiểm tra lại"
            );
        }
        if (this.isKhoaLuong[keyRequest]) return;
        $store.startLoading();
        this.isKhoaLuong[keyRequest] = "pending...";
        try {
            let rs = await $store.dispatch(dispatch, {
                ServicesBE,
                url,
                dataPost,
            });

            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                $Helper.ThongBaoToast("success", msgSuccess);
            } else {
                $Helper.ThongBaoToast(
                    "error",
                    msgError + (rs.message || rs.Message || "")
                );
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            $Helper.ThongBaoToast("error", msgCatch);
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: "Catch!",
            };
        } finally {
            this.isKhoaLuong[keyRequest] = undefined;
            $store.stopLoading();
        }
    };
    this.StoreRequestGet = async ({
        ServicesBE = "Make",
        dispatch = "Common/RequestGetData",
        url = "",
        dataGet = null,
        msgSuccess = null,
        msgError = null,
        msgCatch = null,
    }) => {
        $store.startLoading();
        try {
            let rs = await $store.dispatch(dispatch, {
                ServicesBE,
                url,
                dataGet,
            });
            if (
                (rs.hasOwnProperty("status") && rs.status) ||
                (rs.hasOwnProperty("State") && rs.State == "Success")
            ) {
                if (msgSuccess) {
                    $Helper.ThongBaoToast("success", msgSuccess);
                }
            } else {
                if (msgError) {
                    $Helper.ThongBaoToast(
                        "error",
                        msgError + " " + (rs.message || rs.Message || "")
                    );
                }
            }
            return rs;
        } catch (error) {
            console.log("🚀 ~ error:", error);
            if (msgCatch) {
                $Helper.ThongBaoToast("error", msgCatch);
            }
            return {
                status: false,
                data: null,
                errorCode: 0,
                message: "Catch!",
            };
        } finally {
            $store.stopLoading();
        }
    };

    this.CatchRequest = (ex) => {
        if (ex.StatusCode && ex.StatusCode == 400) {
            let strError = "";
            let data = ex.Data?.errors || ex.Data?.data;
            if (data) {
                let type = Object.prototype.toString.call(data);
                if (type === "[object Array]") {
                    data.forEach((e) => {
                        strError += `- ${e.description || e.message}\n`;
                    });
                } else if (type === "[object Object]") {
                    for (const key in data) {
                        if (Object.prototype.hasOwnProperty.call(data, key)) {
                            const element = data[key];
                            (element || []).forEach((e, i) => {
                                strError += `- ${e}\n`;
                            });
                        }
                    }
                }
            }
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Dữ liệu gửi đi không hợp lệ!",
                message: strError
                    ? strError
                    : `Vui lòng kiểm tra lại hoặc liên hệ kỹ thuật viên hoặc gọi điện đến số "1900.4751 - nhánh 2" để được hỗ trợ.`,
                statusCode: 400,
            });
        }
        if (ex.StatusCode && ex.StatusCode == 401) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Lỗi không thể xác thực tài khoản!",
                message: "Vui lòng đăng nhập lại để thực hiện.",
                statusCode: 401,
            });
        }
        if (ex.StatusCode && ex.StatusCode == 403) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Không có quyền truy cập!",
                message:
                    ex.Data?.message ||
                    "Bạn không có quyền truy cập dữ liệu này!",
                statusCode: 403,
            });
        }
        if (ex.StatusCode && ex.StatusCode == 404) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Không tìm thấy dữ liệu!",
                message:
                    ex.Data?.message ||
                    "Không tìm thấy dữ liệu dữ liệu này trên hệ thống!",
                statusCode: 403,
            });
        }
        if (ex.StatusCode && ex.StatusCode == 409) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Dữ liệu đã tồn tại!",
                message:
                    ex.Data?.message ||
                    "Dữ liệu bạn vừa thao tác đã tồn tại trong hệ thống!",
                statusCode: 409,
            });
        }
        if (ex.StatusCode && ex.StatusCode >= 500) {
            $Helper.ThongBaoPopup({
                type: "Error",
                message_title: "Lỗi kết nối đến máy chủ!",
                message: `Vui lòng liên hệ kỹ thuật viên hoặc gọi điện đến số "1900.4751 - nhánh 2" để được hỗ trợ.`,
                statusCode: ex.StatusCode,
            });
        }
    };

    this.GetMessageCatchRequest = (ex) => {
        let strError = "";
        if (ex.StatusCode && ex.StatusCode == 400) {
            let data = ex.Data?.errors || ex.Data?.data;
            if (data) {
                let type = Object.prototype.toString.call(data);
                if (type === "[object Array]") {
                    data.forEach((e) => {
                        strError += `- ${e.description || e.message}\n`;
                    });
                } else if (type === "[object Object]") {
                    for (const key in data) {
                        if (Object.prototype.hasOwnProperty.call(data, key)) {
                            const element = data[key];
                            (element || []).forEach((e, i) => {
                                strError += `- ${e}\n`;
                            });
                        }
                    }
                }
            }
            if (!strError) {
                strError = `Dữ liệu gửi đi không hợp lệ! Vui lòng kiểm tra lại hoặc liên hệ kỹ thuật viên hoặc gọi điện đến số "1900.4751 - nhánh 2" để được hỗ trợ.`;
            }
        }
        if (ex.StatusCode && ex.StatusCode == 401) {
            strError = `Lỗi không thể xác thực tài khoản! Vui lòng đăng nhập lại để thực hiện.`;
        }
        if (ex.StatusCode && ex.StatusCode == 403) {
            strError = `Không có quyền truy cập! Bạn không có quyền truy cập dữ liệu này.`;
        }
        if (ex.StatusCode && ex.StatusCode == 404) {
            strError = `Không tìm thấy dữ liệu! Không tìm thấy dữ liệu dữ liệu này trên hệ thống.`;
        }
        if (ex.StatusCode && ex.StatusCode == 409) {
            strError = `Dữ liệu đã tồn tại! Dữ liệu bạn vừa thao tác đã tồn tại trong hệ thống.`;
        }
        if (ex.StatusCode && ex.StatusCode >= 500) {
            strError = `Lỗi kết nối đến máy chủ! Vui lòng liên hệ kỹ thuật viên hoặc gọi điện đến số "1900.4751 - nhánh 2" để được hỗ trợ.`;
        }
        return strError;
    };

    this.Common = Devextreme;
}
